import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { FatFillComponent } from '../tabs/fat/fat-fill.component';

@Component({
  selector: 'app-fat-page',
  standalone: true,
  imports: [CommonModule, MatIconModule, FatFillComponent],
  templateUrl: './fat-page.component.html',
  styleUrl: './fat-page.component.scss'
})
export class FatPageComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  get projectId(): number {
    return +(this.route.snapshot.paramMap.get('projectId') || 0);
  }

  get fatId(): number {
    return +(this.route.snapshot.paramMap.get('fatId') || 0);
  }

  navigateBack(): void {
    this.router.navigate(['/projects/edit', this.projectId], { queryParams: { tab: 'fat' } });
  }
}
